import {
  LoadingSpinner,
  OrgTree,
  Tooltip,
  useCurrentCompany,
} from '@employ-engage/common-components';
import { useState } from 'react';
import SetupOrganizationTreeForm from '../setup-organization-tree-form/setup-organization-tree-form';
import { OrgTreeItem } from '@employ-engage/data';
import ManagementRolesForm from '../management-roles-form/management-roles-form';
import { useTranslation } from 'react-i18next';

export function SetupSettings() {
  const { t } = useTranslation(['common']);
  const [collapseOrganizationTree, setCollapseOrganizationTree] =
    useState<boolean>(false);
  const { currentCompany, loading, refetchCompany } = useCurrentCompany();

  const onExpandOrganizationTree = () => {
    setCollapseOrganizationTree(false);
  };
  const onCollapseOrganizationTree = () => {
    setCollapseOrganizationTree(true);
  };

  if (loading || !currentCompany) {
    return <LoadingSpinner spinnerId="setup-settings-loading" />;
  }

  return (
    <div>
      <h2 className="roles-label text-lg font-bold">{t('Roles')}</h2>
      <ManagementRolesForm
        managementRoles={
          currentCompany?.managementRoles || []
        }
      />
      <hr className="my-4" />
      <h2 className="company-level-label text-lg font-bold">
        {t('Organization Levels')}
      </h2>
      <SetupOrganizationTreeForm
        nextLevelKeys={currentCompany?.orgTreeNextLevelKeys || []}
        refetchCompany={refetchCompany}
      />
      <hr className="my-4" />
      <div className="flex items-center">
        <h2 className="text-lg font-bold">{t('Organization Tree')}</h2>
        <div className="ml-2">
          <Tooltip label={t('Expand Organization Tree')}>
            <button onClick={onExpandOrganizationTree}>
              <i className="fa-solid fa-up-right-and-down-left-from-center cursor-pointer" />
            </button>
          </Tooltip>
        </div>
        <div className="ml-2">
          <Tooltip label={t('Collapse Organization Tree')}>
            <button onClick={onCollapseOrganizationTree}>
              <i className="fa-solid fa-down-left-and-up-right-to-center cursor-pointer" />
            </button>
          </Tooltip>
        </div>
      </div>
      {!!currentCompany && !!currentCompany?.orgTreeNextLevelKeys?.length && (
        <OrgTree
          isEditable
          isCollapsible
          path={[]}
          level={0}
          company={currentCompany}
          completeOrgTree={currentCompany?.orgTree as OrgTreeItem}
          data={currentCompany?.orgTree as OrgTreeItem}
          nextLevelKeys={currentCompany.orgTreeNextLevelKeys}
          collapseOrganization={collapseOrganizationTree}
          refetchCompany={refetchCompany}
        />
      )}
    </div>
  );
}

export default SetupSettings;
